module.exports = __webpack_public_path__ + "img/arrecredi_bdon_4_1.6349e366.webp";